module.exports = __webpack_public_path__ + "img/installing_mounting_wedge_non-wired.ebc7eb71.png";